/* eslint-disable no-unused-expressions */
import * as React from "react";
import { Table, Button } from "antd";
import { useState, useEffect } from "react";
import { Space } from "antd";
import "dayjs/locale/es";
import { BellFilled } from "@ant-design/icons";

import dayjs from "dayjs";
import calendar from "dayjs/plugin/calendar";

import {
  toColombianPesos,
  formatIntDate,
  formatDate,
} from "../../../utils/utils";

dayjs.extend(calendar);

export const ProductsTable = ({
  dataSource,
  onHandleEvent,
  onConfirm,
  enabledToEdit,
}) => {
  const [tableData, setTableData] = useState(dataSource);
  const [selectedRows, setSelectedRows] = useState([]);

  useEffect(() => {
    const newData = [...tableData];
    setTableData(newData);
  }, []);

  const handleOnConfirm = () => {
    onConfirm(selectedRows);
    onHandleEvent(selectedRows[0]);
  };

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      console.log(
        `selectedRowKeys: ${selectedRowKeys}`,
        "selectedRows: ",
        selectedRows
      );
      setSelectedRows(selectedRows)
    },
  };

  const columns = [
    {
      title: "Material",
      dataIndex: "material",
    },
    {
      title: "Cant. Total",
      dataIndex: "cantidad",
    },
    {
      title: "Costo",
      dataIndex: "costo",
      render: (cost) => <span>{toColombianPesos(cost)}</span>,
    },
    {
      title: "Fecha Promesa",
      dataIndex: "fechaPromesa",
      render: (text) => (text ? formatIntDate(text.toString()) : ""),
    },
    {
      title: "Fecha Entrega",
      dataIndex: "fechaEntrega",
      render: (text) => (text ? formatIntDate(text.toString()) : ""),
    },
    {
      title: "Tirilla",
      dataIndex: "tirilla",
      key: "tirilla",
    },
    {
      title: "Referencia",
      dataIndex: "referencia",
    },
    {
      title: "Acciones",
      dataIndex: "acciones",
      fixed: "right",
      width: 100,
      render: (_, record) => (
        <Space size="middle">
          <Button type="link" onClick={() => onHandleEvent(record)}>
            Mostrar Eventos
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <div className="products-editable">
      {(selectedRows && selectedRows.length > 0) && (
        <div className="products-editable-actions">
          <Button
            type="default"
            onClick={handleOnConfirm}
            className="btn-primary"
          >
            <BellFilled /> Crear Llamada / Novedad
          </Button>
        </div>
      )}

      <Table
        rowSelection={{
          type: "checkbox",
          ...rowSelection,
        }}
        rowKey="id"
        columns={columns}
        dataSource={tableData.map((d, i) => {
          return { id: d.posicion, ...d };
        })}
        pagination={false}
      />
    </div>
  );
};
